/* eslint max-lines: 0 */
export interface Route {
  path: string;
  name: string;
  matchPattern?: string;
  route: string;
}

// TODO: idea - path as a function which tells required parameters needed for path
const config = {
  web: { path: '/web', route: '/web/*', name: 'Web', matchPattern: '/web/*' },
  shares: {
    path: '/web/shares',
    route: 'shares',
    name: 'Shares',
  },
  auddlySignUp: {
    path: '/web/auddly',
    route: 'auddly/*',
    name: 'Auddly Sign Up',
    matchPattern: '/web/auddly/*',
  },
  auddlySignUpLocation: {
    path: '/web/auddly/location',
    route: '/location',
    name: 'Auddly Sign Up Location',
  },
  auddlySignUpPassword: {
    path: '/web/auddly/password',
    route: '/password',
    name: 'Auddly Sign Up Password',
  },
  webPageNotFound: {
    path: '/web/404',
    route: '404',
    name: 'Page not found',
  },
  play: {
    path: '/play',
    route: '/play/*',
    name: 'Play',
    matchPattern: '/play/*',
  },
  sharesPlay: {
    path: '/play/:shareToken',
    route: ':shareToken',
    name: 'Shares Play',
  },
  sharesPlayLyrics: {
    path: '/play/:shareToken/lyrics',
    route: 'lyrics',
    name: 'Player lyrics',
  },
  appRedirect: {
    path: '/app-redirect',
    route: '/app-redirect',
    name: 'App Redirect',
  },
  qrCheckin: {
    path: '/qr-checkin',
    route: '/qr-checkin',
    name: 'QR Check-in',
  },
  qrLanding: {
    path: '/qr',
    route: '/qr',
    name: 'QR',
  },
  auth: { path: '/auth', route: '/auth', name: 'Auth' },
  passwordReset: {
    path: '/password-reset',
    route: '/password-reset',
    name: 'Password Reset',
  },
  confirmAccount: {
    path: '/sign-up/confirm',
    route: '/sign-up/confirm',
    name: 'Confirm Account',
  },
  confirmAccountSuccess: {
    path: '/sign-up/confirm/success',
    route: '/sign-up/confirm/success',
    name: 'Confirm Account Success',
  },
  signIn: {
    path: '/sign-in',
    route: '/sign-in',
    name: 'Sign In',
  },
  signUp: {
    path: '/sign-up',
    route: '/sign-up/*',
    name: 'Sign Up',
    matchPattern: '/sign-up/*',
  },
  signUpBasic: {
    path: '/sign-up/basic',
    route: '/basic',
    name: 'Sign Up Basic',
  },
  signUpDetails: {
    path: '/sign-up/details',
    route: '/details',
    name: 'Sign Up Details',
  },
  signUpPersona: {
    path: '/sign-up/persona',
    route: '/persona',
    name: 'Sign Up Persona',
  },
  signOut: { path: '/sign-out', route: '/sign-out', name: 'Sign Out' },
  profile: {
    path: '/profile',
    route: 'profile/*',
    name: 'Profile',
    matchPattern: '/profile/*',
  },
  profileBasic: { path: '/profile/basic', route: 'basic', name: 'Basic' },
  profileIDs: { path: '/profile/ids', route: 'ids', name: 'IDs' },
  profileConnections: {
    path: '/profile/connections',
    route: 'connections',
    name: 'Connections',
  },
  profileCredits: {
    path: '/profile/credits',
    route: 'credits',
    name: 'Credits',
  },
  profileRepresentatives: {
    path: '/profile/representatives',
    route: 'representatives',
    name: 'Representatives',
  },
  releases: { path: '/releases', route: '/releases/*', name: 'Releases' },
  release: {
    path: '/releases/:guid',
    route: '/releases/:guid',
    name: 'Release',
  },
  releaseVersion: {
    path: '/releases/:guid/versions/:versionGuid',
    route: '/releases/:guid/versions/:versionGuid/*',
    name: 'Release Version',
    matchPattern: '/releases/:guid/versions/:versionGuid/*',
  },
  releaseVersionDetails: {
    path: '/releases/:guid/versions/:versionGuid/details',
    route: 'details',
    name: 'Details',
  },
  releaseVersionAudio: {
    path: '/releases/:guid/versions/:versionGuid/audio',
    route: 'audio',
    name: 'Audio',
  },
  releaseVersionLyrics: {
    path: '/releases/:guid/versions/:versionGuid/lyrics',
    route: 'lyrics',
    name: 'Lyrics',
  },
  releaseVersionCredits: {
    path: '/releases/:guid/versions/:versionGuid/credits',
    route: 'credits',
    name: 'Credits',
  },
  releaseVersionSplits: {
    path: '/releases/:guid/versions/:versionGuid/splits',
    route: 'splits',
    name: 'Split',
  },
  songs: { path: '/songs', route: '/songs', name: 'Songs' },
  songFolder: {
    path: '/folders/:guid',
    route: 'folders/:guid',
    name: 'Songs Group',
  },
  song: {
    path: '/songs/:guid',
    route: '/songs/:guid/*',
    name: 'Song',
    matchPattern: '/songs/:guid/*',
  },
  songContributions: {
    path: '/songs/:guid/contributions',
    route: 'contributions',
    name: 'Credits',
  },
  songContribution: {
    path: '/songs/:guid/contributions/:contributionGuid',
    route: 'contributions/:contributionGuid',
    name: 'Credit',
  },
  newSongContribution: {
    path: '/songs/:guid/contributions/new',
    route: 'contributions/new',
    name: 'New Credit',
  },
  songAudioList: {
    path: '/songs/:guid/audio',
    route: 'audio',
    name: 'Audio',
  },
  songLyrics: {
    path: '/songs/:guid/lyrics',
    route: 'lyrics',
    name: 'Lyrics',
  },
  songDetails: {
    path: '/songs/:guid/details',
    route: 'details',
    name: 'Details',
  },
  songCollaborators: {
    path: '/songs/:guid/collaborators',
    route: 'collaborators',
    name: 'Access',
  },
  songCollaborator: {
    path: '/songs/:guid/collaborator',
    route: '/collaborator',
    name: 'Collaborator',
  },
  songSplits: {
    path: '/songs/:guid/splits',
    route: 'splits',
    name: 'Splits',
  },
  settings: {
    path: '/settings',
    route: '/settings',
    name: 'Settings',
    matchPattern: '/settings',
  },
  privacySettings: {
    path: '/settings/privacy',
    route: '/settings/privacy',
    name: 'Privacy',
    matchPattern: '/settings/privacy',
  },
  notifications: {
    path: '/notifications',
    route: '/notifications',
    name: 'Notifications',
  },
  messages: {
    path: '/messages',
    route: '/messages',
    name: 'Messages',
  },
  playlists: {
    path: '/playlists',
    route: '/playlists',
    name: 'Playlists',
  },
  playlist: {
    path: '/playlists/:guid',
    route: '/playlists/:guid',
    name: 'Playlist',
  },
  playerPlaylist: {
    path: '/playlists/player',
    route: '/playlists/player',
    name: 'Player playlist',
  },
  playerLyrics: {
    path: '/songs/lyrics/player',
    route: '/songs/lyrics/player',
    name: 'Player lyrics',
  },
  import: {
    path: '/import',
    route: '/import',
    name: 'Import',
  },
  pageNotFound: {
    path: '/404',
    route: '/404',
    name: 'Page not found',
  },
};

type routesType = typeof config;

export const routes: routesType = config;

export const publicRoutes = [
  routes.confirmAccount.path,
  routes.confirmAccountSuccess.path,
];

export const mobileCompatibleRoutes = publicRoutes.concat([
  routes.signUp.path,
  routes.signUpBasic.path,
  routes.signUpDetails.path,
  routes.signUpPersona.path,
  routes.passwordReset.path,
  routes.auddlySignUp.path,
  routes.auddlySignUpLocation.path,
  routes.auddlySignUpPassword.path,
  routes.profile.path,
  routes.profileBasic.path,
  routes.settings.path,
  routes.signOut.path,
  routes.pageNotFound.path,
  routes.auth.path,
  routes.signIn.path,
  `${routes.settings.path}/account`, // TODO: temp fix. remove when SS-7743 is implemented
]);
